import { Component, computed, input } from '@angular/core';
import { EnrollmentStatus } from '@lb/api/mylb/enums/enrollment-status.enum';
import { MDTagComponent } from '@melodic-ui/components';
import { IndicatorType } from '@melodic-ui/types';

/**
 * The tag tone for an enrollment status — the colours the enrollment cards use. Exported so the
 * Grade Reports' Course Status tag reads the same colour for the same status (Ben, 2026-09-23).
 */
export function enrollmentStatusTagType(enrollmentStatusID: EnrollmentStatus | undefined): IndicatorType {
	switch (enrollmentStatusID) {
		case EnrollmentStatus.ReadyToStart:
		case EnrollmentStatus.InProgress:
			return 'success';
		case EnrollmentStatus.Paused:
			return 'warning';
		case EnrollmentStatus.MIA:
			return 'error';
		default:
			return 'tertiary';
	}
}

@Component({
	selector: 'lb-enrollment-tag',
	standalone: true,
	imports: [MDTagComponent],
	template: `
		<md-tag [type]="tagType()">
			{{ statusName() }}
		</md-tag>
	`
})
export class EnrollmentTagComponent {
	enrollmentStatusID = input.required<EnrollmentStatus | undefined>();
	enrollmentStatus = input.required<string | undefined>();
	isLearner = input.required<boolean>();

	statusName = computed(() => {
		if (!this.isLearner()) return this.enrollmentStatus() ?? 'Unknown Status';

		const enrollmentStatusID = this.enrollmentStatusID();

		switch (enrollmentStatusID) {
			case EnrollmentStatus.MIA:
				return 'Paused - Awaiting Response';

			case EnrollmentStatus.OnLeaveOfAbsence:
				return 'Leave of Absence';

			default:
				return this.enrollmentStatus() ?? 'Unknown Status';
		}
	});

	tagType = computed(() => enrollmentStatusTagType(this.enrollmentStatusID()));
}
